import React from "react";
import PropTypes from "prop-types";

const SwapIcon = ({ width, height, color, strokeWidth, className, ...props }) => (
  <svg
    width={width || 16}
    height={height || 16}
    viewBox="0 0 24 24"
    fill="none"
    stroke={color}
    strokeWidth={strokeWidth}
    strokeLinecap="round"
    strokeLinejoin="round"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
    {...props}
  >
    <path d="m16 3 4 4-4 4" />
    <path d="M20 7H4" />
    <path d="m8 21-4-4 4-4" />
    <path d="M4 17h16" />
  </svg>
);

SwapIcon.propTypes = {
  width: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  height: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  color: PropTypes.string,
  strokeWidth: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  className: PropTypes.string,
};

SwapIcon.defaultProps = {
  width: undefined,
  height: undefined,
  color: "currentColor",
  strokeWidth: 2,
  className: "",
};

export default SwapIcon;
